module.exports = __webpack_public_path__ + "static/media/sad_face.fc491214.png";